import axios from "./backend";
import { URL } from "url";

import { BACKEND_ROOT } from "config/constants";

export const getRedirectPath = (req, uuid, context) => {
  return axios
    .get(`${BACKEND_ROOT}/api/render/lookup/${uuid}/`)
    .then(resp => {
      const parsedUrl = new URL(resp.data.permalink);

      // If the permalink is different than the url that was requested, pass redirect in context.
      if (parsedUrl.pathname != req.path) {
        context.status = 301;
        context.path = parsedUrl.pathname;
      }
    })
    .catch(() => Promise.resolve());
};
